<template>
  <div class="header-box min-width">
    <div class="container-left">
      <div class="logo-box">
        <img class="logo1" src="../../assets/images/new/logo.png" alt />
      </div>
      <div class="logo-text">广西华之茂投资集团有限公司</div>
    </div>
    <div class="container-mid">
      <div
        class="tabs-item"
        v-for="(item, index) in navigationList"
        :key="index"
        @click="handleStudentJump(item.appCode, item.sort)"
      >
        <div :class="{ active: $route.name == item.appCode }">
          {{ item.languageKey }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    from: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowh: true,
      studentInfo: {},
      signText: '',
      currentAuth: '',
      defaultLanguage: '',
      isManageAdmin: '',
      isStudent: '',
      navigationList: [
        {
          appCode: 'home',
          languageKey: '首页',
          menuType: 'TOP_NAVIGATION',
          name: 'home',
          parentId: '0',
          sort: 0,
          url: '/home',
          both: ['home']
        },
        {
          appCode: 'about',
          languageKey: '关于我们',
          menuType: 'TOP_NAVIGATION',
          name: 'about',
          parentId: '0',
          sort: 1,
          url: '/about',
          both: ['learningCenter']
        },
        {
          appCode: 'news',
          languageKey: '项目展示',
          menuType: 'TOP_NAVIGATION',
          name: 'news',
          parentId: '0',
          sort: 2,
          url: '/news',
          both: ['newsDetail']
        },
        // {
        //   appCode: 'project',
        //   languageKey: '项目展示',
        //   menuType: 'TOP_NAVIGATION',
        //   name: 'project',
        //   parentId: '0',
        //   sort: 4,
        //   url: '/project',
        //   both: [
        //     'userLearning',
        //     'userCourse',
        //     'userExam',
        //     'userTasks',
        //     'userCredit',
        //     'userCertificate'
        //   ]
        // },
        // {
        //   appCode: 'tenderInfo',
        //   languageKey: '招标信息',
        //   menuType: 'TOP_NAVIGATION',
        //   name: 'tenderInfo',
        //   parentId: '0',
        //   sort: 4,
        //   url: '/tender-info',
        //   both: [
        //     'userLearning',
        //     'userCourse',
        //     'userExam',
        //     'userTasks',
        //     'userCredit',
        //     'userCertificate'
        //   ]
        // },
        {
          appCode: 'callMe',
          languageKey: '联系我们',
          menuType: 'TOP_NAVIGATION',
          name: 'callMe',
          parentId: '0',
          sort: 3,
          url: '/call-me',
          both: [
            'userLearning',
            'userCourse',
            'userExam',
            'userTasks',
            'userCredit',
            'userCertificate'
          ]
        }
      ]
    }
  },
  mounted () {},
  methods: {
    handleStudentJump (name, sort) {
      this.$store.commit('UPDTAE_BANNER_INDEX', sort)
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-box {
  // position: fixed;
  // top: 0;
  // left: 0;
  // z-index: 999;
  width: 100%;
  height: 42px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .container-left {
    display: flex;
    align-items: center;
    margin-right: 170px;
    .logo-box {
      display: flex;
      align-items: center;
      justify-content: center;
      .logo1 {
        width: 25px;
        margin-right: 20px;
        border-radius: 50%;
      }
      .logo2 {
        width: 28px;
        margin-left: 10px;
        margin-right: 20px;
      }
    }
    .logo-text {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 15px;
      color: #323234;
    }
  }
  .container-mid {
    // flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .tabs-item {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 15px;
      color: #1046ac;
      zoom: 0.9;
      cursor: pointer;
      margin: 0 19px;
      .active {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 15px;
        color: #1046ac;
        &::after {
          width: 13px;
          height: 2px;
          background: #da2419;
        }
      }
    }
  }
}
</style>
